<template>
	<div class="border-top">
		<SOFilterTitle :title="'Kategori Layanan'" :id="id" />
		<div class="p-l-24 p-r-24 p-d-24" :id="id">
			<SOInputCheckbox :checkboxes="kategoriLayanan" @selected="selected" />
		</div>
	</div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterKategoriLayanan",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
	},
	data() {
		return {
			kategoriLayanan: {
				name: "kategoriLayanan",
				data: [
					{
						id: "fklayanan-1",
						value: "Layanan A",
						title: "Layanan A",
						checked: false,
						titleBold: false,
					},
					{
						id: "fklayanan-2",
						value: "Layanan B",
						title: "Layanan B",
						checked: false,
						titleBold: false,
					},
				]
			},
		}
	},
	methods: {
		selected(val) {
			this.$emit("selected", val);
		}
	}
}
</script>